export enum ChatMessagePayloadType {
  message = "message",
  group_info = "group_info",
  typingIndicator = "typing_indicator",
  call = "call",
  digest = "digest",
  task_reminder = "task_reminder",
}
